import { faChevronDown, faPen } from '@fortawesome/pro-regular-svg-icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';

interface AutomationGroupHeaderActionsProps {
  collapsed: boolean;
  onRename: () => void;
  onToggleCollapse: () => void;
}

export const AutomationGroupHeaderActions: FC<AutomationGroupHeaderActionsProps> = ({
  collapsed,
  onRename,
  onToggleCollapse,
}) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" gap={0.5}>
      <IconButton
        aria-label={t('automations.groups.editGroup')}
        onClick={onRename}
        size="small"
      >
        <Icon icon={faPen} size="small" />
      </IconButton>
      <IconButton
        aria-expanded={!collapsed}
        aria-label={
          collapsed
            ? t('automations.groups.expandGroup')
            : t('automations.groups.collapseGroup')
        }
        onClick={onToggleCollapse}
        size="small"
      >
        <Icon
          icon={faChevronDown}
          size="small"
          sx={{
            transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
            transition: 'transform 0.2s ease',
          }}
        />
      </IconButton>
    </Box>
  );
};
